import { createRequest } from "helpers/tools";

export const getBigqueryUrl = async () => {
    return await createRequest({
        suffix: `google/bigquery/auth-url?type=source`,
        handleError: true,
        method: "get",
    });
};

export const getBigqueryTrackerEvent = async (sourceId) => {
    return await createRequest({
        suffix: `google/bigquery/${sourceId}/preview`,
        method: "get",
        handleError: false,
    });
};

export const bigqueryReconnect = async (id, data) => {
    return await createRequest({
        suffix: `sources/${id}/service-update`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const bigqueryAuthorize = async (data) => {
    return await createRequest({
        suffix: `google/bigquery/authorize`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
export const getBigquerySettings = async (id) => {
    return await createRequest({
        suffix: `sources/schedule-settings?source_type=bigquery`,
        handleError: true,
        method: "get",
    });
};

export const postBigquerySettings = async (payload) => {
    return await createRequest({
        suffix: `sources/schedule-settings`,
        handleError: true,
        method: "post",
        payload,
    });
};

export const getBigqueryTables = async (
    user_selected_project_id,
    user_selected_dataset_id,
    install_id,
) => {
    return await createRequest({
        suffix: `google/bigquery/tables?project=${user_selected_project_id}&dataset=${user_selected_dataset_id}&install_id=${install_id}`,
        method: "get",
        handleError: false,
    });
};

export const runBigqueryFileJob = async (sourceId, { file_job_id, mode }) => {
    return await createRequest({
        suffix: `sources/service/${sourceId}/run-bigquery-file-job`,
        method: "post",
        payload: { file_job_id, mode },
        handleError: false,
    });
};

export const createSourceBigquery = async (data) => {
    return await createRequest({
        suffix: `google/bigquery/store/source`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
